import styled from 'styled-components';

export const ProtectArea = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9999;
  background-color: #ffffff;
  opacity: 0.8;
`;

export const Container = styled.div`
  width: ${(props) => props.size && props.size === 'small' ? '50rem' :
    props.size && props.size === 'auto' ? 'auto' : '80%'};
  border-radius: 20px;
  box-shadow: -10px 0px 40px 2px rgba(0,0,0,0.18);
  background-color: ${(props) => props.containerBackgroundColor ? props.containerBackgroundColor : '#ffffff'} ;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10000;
  text-align: center;

  -webkit-animation: ${(props) => props.open ? 'fadeIn 0.5s ease-in-out' : 'fadeOut 1s ease-in-out'};
  -moz-animation: ${(props) => props.open ? 'fadeIn 0.5s ease-in-out' : 'fadeOut 1s ease-in-out'};
  -o-animation: ${(props) => props.open ? 'fadeIn 0.5s ease-in-out' : 'fadeOut 1s ease-in-out'};
  animation: ${(props) => props.open ? 'fadeIn 0.5s ease-in-out' : 'fadeOut 1s ease-in-out'};

  @-webkit-keyframes fadeIn {
    0% { opacity: 0; visibility: hidden; }
    100% { opacity: 1; visibility: visible; }
  }

  @-moz-keyframes fadeIn {
    0% { opacity: 0; visibility: hidden; }
    100% { opacity: 1; visibility: visible; }
  }

  @-o-keyframes fadeIn {
    0% { opacity: 0; visibility: hidden; }
    100% { opacity: 1; visibility: visible; }
  }

  @keyframes fadeIn {
    0% { opacity: 0; visibility: hidden; }
    100% { opacity: 1; visibility: visible; }
  }

  @-webkit-keyframes fadeOut {
    0% { opacity: 1; visibility: visible; }
    100% { opacity: 0; visibility: hidden; }
  }

  @-moz-keyframes fadeOut {
    0% { opacity: 1; visibility: visible; }
    100% { opacity: 0; visibility: hidden; }
  }

  @-o-keyframes fadeOut {
    0% { opacity: 1; visibility: visible; }
    100% { opacity: 0; visibility: hidden; }
  }

  @keyframes fadeOut {
    0% { opacity: 1; visibility: visible; }
    100% { opacity: 0; visibility: hidden; }
  }

  @media (max-width: 490px) {
    width: 90%;
    overflow-x: auto;
    overflow-x:hidden;
    max-height: 100%;
  }
`;

export const Title = styled.div`
  background-color: ${(props) => {
    if (props.program === 'youngDriver') return '#0079c1';
    if (props.program === 'cnhpop') return '#1EAB61';
    if (props.program === 'whatsapp') return '#ffffff'
    return '#a0ced8';
  }};
  color: #ffffff;
  border-radius: 20px 20px 0px 0px;
  padding: 1.5rem;

  img {
    height: 9rem;
  }

  h1 {
    margin: 1rem 0;
    font-size: 2.6rem;
  }

  @media (max-width: 490px) {
    img {
      height: 7rem;
    }

    h1 {
      font-size: 2.2rem;
    }
  }

  @media (max-width: 380px) {
    padding: 1rem;

    h1 {
      margin: 0.5rem 0;
      font-size: 2rem;
    }
  }
  .titleWithImageAndWhatsAppCommunityContainer{
    display:flex;
    flex-flow: column;
    align-items: center;
    justify-content: center;
  }
  .titleWithImage {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 20px;

    h1 {
      font-family: 'Proxima Nova';
      font-style: normal;
      font-weight: 800;
      font-size: 24px;
      line-height: 24px;

      @media (max-width: 780px) {
        font-style: normal;
        font-weight: 700;
        font-size: 16px;
        line-height: 16px;
      }
    }

    img {
      height: 35px;
      width: 35px;

      @media (max-width: 780px) {
        height: 19px;
        width: 19px;
      }
    }
  }

  
`;

export const Message = styled.div`
  padding: ${(props) => (props.dense ? '3rem' : '3rem 2rem')};
  color: #656565;
  font-size: 2.5rem;

  @media (max-width: 490px) {
    padding: 2rem;
    font-size: 2rem;
  }

  .BodyNextSteps {
    background: #F0EDED;
    border-radius: 19px 19px 0px 0px;
    width: 676px;
    padding: 17px;
    text-align: start;
    padding-top: 10px;
    display: flex;
    flex-direction: column;
    gap: 19px;

    @media (max-width: 780px) {
      width: 100%;
    }

    span {
      text-align: start;
      font-family: 'Proxima Nova';
      font-size: 16px;
      line-height: 16px;
      font-weight: 400;
      color: #585656;

      @media (max-width: 780px) {
        font-style: normal;
        font-size: 14px;
        line-height: 14px;
      }
    }

    strong {
      font-family: 'Proxima Nova';
      font-size: 16px;
      line-height: 16px;
      font-weight: 700;

      @media (max-width: 780px) {
        font-style: normal;
        font-size: 14px;
        line-height: 14px;
      }
    }
  }

  .containerInfo {
    width: 100%;
    display: flex;
    justify-content: center;
    background-color: transparent;
    border-width: 0;
    margin-top: 20.33px;

    .buttonWpp{
      background-color: transparent;
      border-width: 0;
    }
  }

`;

export const Actions = styled.div`
  padding-bottom: 3rem;
  display: flex;
  justify-content: center;

  button {
    margin: 0 1rem;
  }

  @media (max-width: 380px) {
    padding-bottom: 2rem;

    button {
      font-size: 1.6rem;
    }
  }
`;

export const WhatsAppCommunityMessage = styled.div`
  padding: 14px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #22d366;
  width: 716px;

  @media (max-width: 490px) {
    padding: 2rem;
    font-size: 2rem;
  }

  @media (max-width: 780px) {
    width: 100%;
  }

  h1{
    font-family: 'Gotham';
    color: white;
    font-weight: 300;
    font-size: 20px;
    line-height: 24px;
  }
`;